<!-- Nessun <h1> qui: l'header è presente su ogni pagina e il titolo di pagina
     è già l'<h1> della rispettiva feature. Averne due confonde la navigazione
     per intestazioni; l'identità del sito la dà il <title> del documento. -->
<header class="header" [class.header--compact]="isCompact" (keydown.escape)="onEscapeMenu()">
  <!-- Navigazione principale: le voci che portano a una pagina sono link (<a>),
       l'unica azione (apertura del dialog di accesso) resta un <button>.
       La pagina corrente è marcata con aria-current="page" e resa visibile
       anche senza il colore (grassetto + sottolineatura/indicatore). -->
  <nav class="container header__vertical" aria-label="Principale">
    <!-- Top Section -->
    <div class="header__top">
      <div class="header__top-left">
        @if (!isCompact) {
          <ng-container *ngTemplateOutlet="desktopLogos"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="compactLogo"></ng-container>
        }
      </div>
      <div class="header__top-right">
        @if (!isCompact) {
          <ng-container *ngTemplateOutlet="desktopActions"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="compactActions"></ng-container>
        }
      </div>
    </div>
    <!-- Bottom Section (only desktop) -->
    @if (!isCompact) {
      <ng-container *ngTemplateOutlet="desktopBottom"></ng-container>
    }
  </nav>

  <!-- Navigazione per schermi piccoli: sotto i 1024px la navigazione centrale
       dell'header è nascosta, questo menu a scomparsa la sostituisce -->
  @if (isCompact && menuOpen) {
    <nav id="header-mobile-menu" class="header__mobile-nav" aria-label="Navigazione principale">
      <ul class="header__mobile-nav-list">
        <li>
          <a class="header__mobile-nav-link header__mobile-nav-link--band" [routerLink]="'/' + ROUTES.RICERCA"
            [attr.aria-current]="isSearchCurrent('pagine') ? 'page' : null"
            (click)="selectSearch('pagine'); closeMenu()">Cerca nelle pagine</a>
        </li>
        <li>
          <a class="header__mobile-nav-link header__mobile-nav-link--band" [routerLink]="'/' + ROUTES.RICERCA"
            [attr.aria-current]="isSearchCurrent('giornali') ? 'page' : null"
            (click)="selectSearch('giornali'); closeMenu()">Esplora il catalogo</a>
        </li>
        <li>
          <a class="header__mobile-nav-link header__mobile-nav-link--plain" [routerLink]="'/' + ROUTES.PROGETTO"
            routerLinkActive ariaCurrentWhenActive="page" (click)="closeMenu()">Il progetto</a>
        </li>
      </ul>
      @if (!loggedIn) {
        <button type="button" class="header__mobile-nav-access" (click)="openAccessFromMenu()">
          <img [src]="SVG_ASSETS.USER" alt="" aria-hidden="true" class="header__mobile-nav-access-icon" />
          Accesso riservato
        </button>
      }
      <div class="header__mobile-nav-logos">
        <a [href]="CONTATTI.CONSIGLIO.WEBSITE" target="_blank" rel="noopener noreferrer" aria-label="Consiglio Regionale del Piemonte (apre in una nuova finestra)">
          <img [src]="IMAGE_ASSETS.LOGO_CONSIGLIO_HEADER" [alt]="CONTATTI.CONSIGLIO.NOME" class="header__img" />
        </a>
        <a [href]="CONTATTI.REGIONE.WEBSITE" target="_blank" rel="noopener noreferrer" aria-label="Regione Piemonte (apre in una nuova finestra)">
          <img [src]="IMAGE_ASSETS.LOGO_REGIONE_HEADER" [alt]="CONTATTI.REGIONE.NOME" class="header__img" />
        </a>
      </div>
    </nav>
  }
</header>

<ng-template #desktopLogos>
  <!-- Un solo nome accessibile per link: il testo sta nell'alt dell'immagine,
       senza aria-label sul <a> (che lo sovrascriverebbe duplicandolo) -->
  <a [href]="CONTATTI.CONSIGLIO.WEBSITE" target="_blank" rel="noopener noreferrer">
    <img [src]="IMAGE_ASSETS.LOGO_CONSIGLIO_HEADER" alt="Consiglio Regionale del Piemonte (apre in una nuova finestra)" class="header__img" />
  </a>
  <a [href]="CONTATTI.REGIONE.WEBSITE" target="_blank" rel="noopener noreferrer">
    <img [src]="IMAGE_ASSETS.LOGO_REGIONE_HEADER" alt="Regione Piemonte (apre in una nuova finestra)" class="header__img" />
  </a>
</ng-template>

<ng-template #compactLogo>
  <button #menuBtn type="button" class="header__menu-btn" aria-label="Menu di navigazione"
    aria-controls="header-mobile-menu" [attr.aria-expanded]="menuOpen" (click)="toggleMenu()">
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      @if (menuOpen) {
        <path d="M6 6l12 12M18 6L6 18" />
      } @else {
        <path d="M4 7h16M4 12h16M4 17h16" />
      }
    </svg>
  </button>
  <a routerLink="/">
    <img [src]="IMAGE_ASSETS.LOGO_GIORNALI" alt="Home - Giornali Piemonte" class="header__bottom-icon header__top-left-compact" />
  </a>
</ng-template>

<ng-template #desktopActions>
  <div class="header__desktop-actions-gap">
    <a
      class="header__link"
      [routerLink]="'/' + ROUTES.PROGETTO"
      routerLinkActive
      ariaCurrentWhenActive="page"
      >Il Progetto</a
    >
    <ui-button class="header__btn-primary" (onButtonClick)="openDialog()">
      <div class="header__btn-content">
        <span class="header__btn-icon">
          <img [src]="SVG_ASSETS.USER" alt="" aria-hidden="true" class="header__user-icon" />
        </span>
        {{ loggedIn ? currentName : 'Accesso Riservato' }}
      </div>
    </ui-button>
  </div>
</ng-template>

<ng-template #compactActions>
  <div class="header__top-compact-center">
    <a
      class="header__link header__link--tab compact-text-cta compact-search-text"
      [routerLink]="'/' + ROUTES.RICERCA"
      [attr.aria-current]="isSearchCurrent('pagine') ? 'page' : null"
      (click)="selectSearch('pagine')"
      >Cerca nelle pagine</a
    >
    <a
      class="header__link header__link--tab compact-text-cta compact-explore-text"
      [routerLink]="'/' + ROUTES.RICERCA"
      [attr.aria-current]="isSearchCurrent('giornali') ? 'page' : null"
      (click)="selectSearch('giornali')"
      >Esplora il catalogo</a
    >
  </div>

  <!-- Link-icona: il nome accessibile viene dal testo nascosto, non da un aria-label
       (che sul <ui-button> padre restava anche sull'host, duplicato) -->
  @if (loggedIn) {
    <a
      class="header__link header__link--icon header__icon-btn"
      [routerLink]="'/' + ROUTES.PREFERITI"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
    >
      <img [src]="SVG_ASSETS.PREFERITI" alt="" aria-hidden="true" class="header__preferito-icon header__preferiti-icon--small" />
      <span class="sr-only">Preferiti</span>
    </a>
  }
  <a
    class="header__link header__link--icon header__icon-btn"
    [routerLink]="'/' + ROUTES.FASCICOLO"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    ariaCurrentWhenActive="page"
    (click)="isDialogOpen = false"
  >
    <img [src]="SVG_ASSETS.FASCICOLO_OUTLINED" alt="" aria-hidden="true" class="header__fascicolo-icon header__fascicolo-icon--small" />
    <span class="sr-only">Fascicolo</span>
  </a>
  <ui-button class="header__icon-btn header__user-compact-btn" [variant]="ButtonVariant.Ghost" [size]="ButtonSize.Icon" (onButtonClick)="openDialog()">
    <img [src]="SVG_ASSETS.USER_OUTLINED" alt="" aria-hidden="true" class="header__user-icon" />
    <span class="sr-only">{{ loggedIn ? currentName : 'Accesso Riservato' }}</span>
  </ui-button>
</ng-template>

<ng-template #desktopBottom>
  <div class="header__bottom">
    <div class="header__bottom-left">
      <a routerLink="/">
        <img [src]="IMAGE_ASSETS.LOGO_GIORNALI" alt="Home - Giornali Piemonte" class="header__bottom-icon" />
      </a>
    </div>
    <div class="header__bottom-center">
      <a
        class="header__link header__link--tab header__link--lg"
        [routerLink]="'/' + ROUTES.RICERCA"
        [attr.aria-current]="isSearchCurrent('pagine') ? 'page' : null"
        (click)="selectSearch('pagine')"
      >
        <span class="header__btn-large-text">Cerca nelle pagine</span>
      </a>
      <a
        class="header__link header__link--tab header__link--lg"
        [routerLink]="'/' + ROUTES.RICERCA"
        [attr.aria-current]="isSearchCurrent('giornali') ? 'page' : null"
        (click)="selectSearch('giornali')"
      >
        <span class="header__btn-large-text">Esplora il catalogo</span>
      </a>
    </div>
    <div class="header__bottom-right">

      @if (loggedIn) {
        <a
          class="header__bottom-right-content header__action-link favorite-action"
          [routerLink]="'/' + ROUTES.PREFERITI"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          ariaCurrentWhenActive="page"
        >
          <span class="header-action-wrapper" aria-hidden="true">
            <img [src]="SVG_ASSETS.PREFERITI_HOVER" alt="" class="header__fascicolo-icon header__fascicolo-icon--outline " />
            <img [src]="SVG_ASSETS.PREFERITI" alt="" class="header__fascicolo-icon header__fascicolo-icon--filled " />
          </span>
          <span class="header__fascicolo-text">Preferiti</span>
        </a>
      }
      <a
        class="header__bottom-right-content header__action-link folder-action"
        [routerLink]="'/' + ROUTES.FASCICOLO"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: true }"
        ariaCurrentWhenActive="page"
      >
        <span class="header-action-wrapper" aria-hidden="true">
          <img [src]="SVG_ASSETS.FASCICOLO" alt="" class="header__fascicolo-icon header__fascicolo-icon--outline" />
          <img [src]="SVG_ASSETS.FASCICOLO_OUTLINED" alt="" class="header__fascicolo-icon header__fascicolo-icon--filled " />
        </span>
        <span class="header__fascicolo-text">Fascicolo</span>
      </a>
    </div>
  </div>
</ng-template>

@if(isDialogOpen) {
<ui-dialog [isCloseable]="true" [centerTitle]="true" (onDismiss)="closeDialog()">
  <div dialog-title>
    <div class="header-dialog-title-tertiary">
      Accedi
    </div>
  </div>

  <div class="header-dialog-desc">
    L'accesso è riservato agli utenti preventivamente accreditati per attività professionali specifiche.
  </div>
  <div class="header-dialog-actions">
    <ui-button [size]="ButtonSize.Lg" (onButtonClick)="accessoRiservato()">Accesso riservato</ui-button>
    <ui-button [size]="ButtonSize.Lg" (onButtonClick)="accessoConsiglioRegionale()">Accesso Consiglio
      Regionale</ui-button>
  </div>
  <div  class="header-dialog-alert">
    <ui-alert>
      Per scoprire come salvare temporaneamente i contenuti di tuo interesse senza autenticazione esplora la sezione
      <a class="fascicolo-link" [routerLink]="'/' + ROUTES.FASCICOLO" (click)="isDialogOpen = false">Fascicolo</a>
    </ui-alert>
  </div>


</ui-dialog>
}
